export default __webpack_public_path__ + "static/media/ic_down_arrow.8560e518.svg";